import React from "react";
import { AvailabilityBlock } from "@/components/features/calendar/AvailabilityBlock/AvailabilityBlock";
import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { FormattedMessage } from "react-intl";
import { DateBlock } from "@/components/features/calendar/types";

interface AvailabilityEditorProps {
  dateBlocks: DateBlock[];
  onConfirmPressed: () => void;
  onViewCalendarPressed: () => void;
  timeZone: string;
}

export const AvailabilityEditor: React.FC<AvailabilityEditorProps> = ({
  dateBlocks,
  onConfirmPressed,
  onViewCalendarPressed,
  timeZone,
}) => {

  return (
    <div className="tw-w-full tw-min-w-[300px]">
      <div className="tw-text-center tw-mb-40">
        <Text typeface="headline-3-b" className="tw-block">
          <FormattedMessage defaultMessage="Please confirm your upcoming weekend availability"/>
        </Text>
        <Text typeface="body-2" className="tw-block tw-mt-16">
          <FormattedMessage defaultMessage="Did you know Saturdays are the most booked days for events? Please take a moment to confirm your availability or update your calendar."/>
        </Text>
      </div>
      <div className="tw-space-y-12">
        {dateBlocks.map((dateBlock, index) => (
          <div key={`${dateBlock.date}-${dateBlock.availability}-${index}`}>
            <AvailabilityBlock
              date={dateBlock.date}
              availability={dateBlock.availability}
              timeZone={timeZone}
            />
          </div>
        ))}
      </div>
      <div className="tw-mt-20 tw-space-y-8">
        <Button fullWidth={true} onClick={onConfirmPressed}>
          <FormattedMessage defaultMessage="Confirm these dates" />
        </Button>
        <Button
          fullWidth={true}
          variant="outline-1"
          onClick={onViewCalendarPressed}
        >
          <FormattedMessage defaultMessage="View or edit calendar" />
        </Button>
      </div>
    </div>
  );
};
